export const toCamelCase = (str) => {
  const [first, ...matches] = str.split(/[^a-zA-Z0-9]/)
  return (
    first.toLowerCase() +
    matches.map((m) => (m ? m[0].toUpperCase() + m.slice(1) : '')).join('')
  )
}
